import { c as _c } from "react/compiler-runtime";
import { EmptyPage } from "@components/common/empty-page/empty-page";
import { EntitiesToolbar } from "@components/common/toolbar/entities-toolbar";
import { GroupDetailsInfoBar } from "@components/group-details/group-details-info-bar";
import { ProjectsSort } from "@components/projects/projects-sort";
import { BulkExportProjects } from "@components/table/projects/bulk-actions/bulk-export-projects";
import { ProjectsTable } from "@components/table/projects/projects-table";
import { ColumnPreferencesProvider } from "@context-providers/table/column-preferences-provider";
import { useFetchProjects } from "@hooks/projects/use-fetch-projects";
import { useMediaQueryList } from "@hooks/use-media-query";
import { ProjectsMobileView } from "@pages/projects/projects-mobile-view";
import { useProjectTableColumnsConfig } from "@pages/projects/projects-utils";
import { useAppSelector } from "@store/store-helper";
import { bulkActionNameSelector, selectedEntitiesSelector } from "@store/table/table-selector";
import { BulkChangeProjectStatus } from "@components/table/projects/bulk-actions/bulk-change-project-status";
import { UtilsTypes } from "@stellar/utils";
import { ProjectsDuoIcon, SearchDuoIcon } from "@flat-ui";
/**
 * Contains the Projects tab of the group details - can display both active and archived projects
 */
export function GroupProjects(t0) {
  const $ = _c(57);
  const {
    companyId,
    groupId,
    group,
    isLoading: t1,
    projectState
  } = t0;
  const isLoading = t1 === undefined ? false : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = selectedEntitiesSelector("projects");
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const selectedEntities = useAppSelector(t2);
  const bulkActionName = useAppSelector(bulkActionNameSelector);
  const {
    isScreenSmOrSmaller
  } = useMediaQueryList();
  const {
    columns: projectTableColumns,
    defaultVisibleColumns: projectTableDefaultVisibleColumns,
    isCompanyContextReady: isProjectTableConfigReady
  } = useProjectTableColumnsConfig();
  let t3;
  if ($[1] !== companyId || $[2] !== groupId || $[3] !== projectState) {
    t3 = {
      companyId,
      projectArchivingState: projectState,
      groupId
    };
    $[1] = companyId;
    $[2] = groupId;
    $[3] = projectState;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const {
    projects,
    isFetchingProjects,
    hasFetchedFirstPage,
    nextPageCursor,
    sortBy,
    setSortBy,
    loadMoreProjects,
    totalCount,
    search,
    isDebouncingSearch
  } = useFetchProjects(t3);
  const isProjectsLoading = isFetchingProjects || isDebouncingSearch || isLoading;
  const shouldShowEmptyPage = !isProjectsLoading && hasFetchedFirstPage && projects.length === 0 && bulkActionName === null;
  const isAnyRowSelected = selectedEntities.length !== 0;
  const shouldRenderActions = projects.length > 0;
  const shouldShowMobileView = isScreenSmOrSmaller && !shouldShowEmptyPage;
  const shouldShowDesktopView = !isScreenSmOrSmaller && !shouldShowEmptyPage;
  let t4;
  if ($[5] !== group || $[6] !== isScreenSmOrSmaller) {
    t4 = !isScreenSmOrSmaller && <GroupDetailsInfoBar group={group} />;
    $[5] = group;
    $[6] = isScreenSmOrSmaller;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== setSortBy || $[9] !== shouldRenderActions || $[10] !== sortBy) {
    t5 = shouldRenderActions && <ProjectsSort key="projects-sort" sortBy={sortBy} setSortBy={setSortBy} />;
    $[8] = setSortBy;
    $[9] = shouldRenderActions;
    $[10] = sortBy;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== companyId || $[13] !== isAnyRowSelected || $[14] !== projectState || $[15] !== projects || $[16] !== selectedEntities || $[17] !== shouldRenderActions) {
    t6 = shouldRenderActions && <BulkExportProjects companyId={companyId} selectedProjects={isAnyRowSelected ? selectedEntities : projects} subjectType="group" projectStatus={projectState} areEntitiesSelected={isAnyRowSelected} buttonType="standard" />;
    $[12] = companyId;
    $[13] = isAnyRowSelected;
    $[14] = projectState;
    $[15] = projects;
    $[16] = selectedEntities;
    $[17] = shouldRenderActions;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== isProjectsLoading || $[20] !== t5 || $[21] !== t6 || $[22] !== totalCount) {
    t7 = <EntitiesToolbar toolbarEntityName="Project" numberOfRows={totalCount} isLoading={isProjectsLoading} sortActions={t5} exportComponent={t6} />;
    $[19] = isProjectsLoading;
    $[20] = t5;
    $[21] = t6;
    $[22] = totalCount;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  let t8;
  if ($[24] !== projectState || $[25] !== projects || $[26] !== search || $[27] !== shouldShowEmptyPage) {
    t8 = shouldShowEmptyPage && <>{search === undefined ? <EmptyPage title={`This group has no ${projectState} projects`} subtitle={projectState === UtilsTypes.ProjectArchivingState.active ? "You don't have any active projects connected to this group. Create a new project or add an existing active project to this group." : "There are no archived projects connected to this group."} icon={ProjectsDuoIcon} /> : <EmptyPage title="No results found" subtitle="There are no projects that match this search." icon={SearchDuoIcon} />}<BulkChangeProjectStatus projectStatus={projectState} projects={projects} /></>;
    $[24] = projectState;
    $[25] = projects;
    $[26] = search;
    $[27] = shouldShowEmptyPage;
    $[28] = t8;
  } else {
    t8 = $[28];
  }
  let t9;
  if ($[29] !== isProjectsLoading || $[30] !== loadMoreProjects || $[31] !== projectState || $[32] !== projects || $[33] !== shouldShowMobileView || $[34] !== sortBy) {
    t9 = shouldShowMobileView && <ProjectsMobileView projects={projects} sortBy={sortBy} isLoading={isProjectsLoading} projectArchivingState={projectState} loadMoreProjects={loadMoreProjects} />;
    $[29] = isProjectsLoading;
    $[30] = loadMoreProjects;
    $[31] = projectState;
    $[32] = projects;
    $[33] = shouldShowMobileView;
    $[34] = sortBy;
    $[35] = t9;
  } else {
    t9 = $[35];
  }
  let t10;
  if ($[36] !== companyId || $[37] !== groupId || $[38] !== isProjectTableConfigReady || $[39] !== isProjectsLoading || $[40] !== loadMoreProjects || $[41] !== nextPageCursor || $[42] !== projectState || $[43] !== projectTableColumns || $[44] !== projectTableDefaultVisibleColumns || $[45] !== projects || $[46] !== setSortBy || $[47] !== shouldShowDesktopView || $[48] !== sortBy || $[49] !== totalCount) {
    t10 = shouldShowDesktopView && isProjectTableConfigReady && <ColumnPreferencesProvider tableKey="group-project-table" columns={projectTableColumns} options={{
      nonConfigurableColumns: ["options"],
      defaultVisibleColumns: projectTableDefaultVisibleColumns
    }}><ProjectsTable companyId={companyId} projects={projects} isLoading={isProjectsLoading} nextPageCursor={nextPageCursor} loadMoreProjects={loadMoreProjects} sortBy={sortBy} setSortBy={setSortBy} groupId={groupId} projectArchivingState={projectState} totalCount={totalCount} /></ColumnPreferencesProvider>;
    $[36] = companyId;
    $[37] = groupId;
    $[38] = isProjectTableConfigReady;
    $[39] = isProjectsLoading;
    $[40] = loadMoreProjects;
    $[41] = nextPageCursor;
    $[42] = projectState;
    $[43] = projectTableColumns;
    $[44] = projectTableDefaultVisibleColumns;
    $[45] = projects;
    $[46] = setSortBy;
    $[47] = shouldShowDesktopView;
    $[48] = sortBy;
    $[49] = totalCount;
    $[50] = t10;
  } else {
    t10 = $[50];
  }
  let t11;
  if ($[51] !== t10 || $[52] !== t4 || $[53] !== t7 || $[54] !== t8 || $[55] !== t9) {
    t11 = <>{t4}{t7}{t8}{t9}{t10}</>;
    $[51] = t10;
    $[52] = t4;
    $[53] = t7;
    $[54] = t8;
    $[55] = t9;
    $[56] = t11;
  } else {
    t11 = $[56];
  }
  return t11;
}